import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Sidebar.css';

const linkClass = ({ isActive }) => (isActive ? 'active' : '');

const Sidebar = ({ open = false, onClose }) => {
  const { role } = useAuth();
  const isMaster = role === 'master';
  const isGroup = role === 'group' || isMaster;

  const closeIfMobile = () => {
    if (typeof window !== 'undefined' && window.matchMedia('(max-width: 900px)').matches) {
      onClose?.();
    }
  };

  return (
    <aside className={`sidebar${open ? ' sidebar-open' : ''}`} aria-hidden={!open}>
      <div className="sidebar-brand">
        <div className="sidebar-brand-row">
          <div>
            <span className="sidebar-brand-mark">Ace Kaatha</span>
            <span className="sidebar-brand-sub">Procurement · Books</span>
          </div>
          <button type="button" className="sidebar-close" onClick={onClose} aria-label="Close menu">
            ×
          </button>
        </div>
      </div>
      <nav onClick={closeIfMobile}>
        <div className="sidebar-section">Ops</div>
        <NavLink to="/dashboard" className={linkClass}>Dashboard</NavLink>
        <NavLink to="/purchases" className={linkClass}>Purchases</NavLink>
        {isGroup && <NavLink to="/aggregation" className={linkClass}>Aggregation</NavLink>}
        <NavLink to="/discounts" className={linkClass}>Discounts</NavLink>
        {isGroup && <NavLink to="/members" className={linkClass}>Members</NavLink>}
        {isMaster && <NavLink to="/brands" className={linkClass}>Brands</NavLink>}
        {isGroup && <NavLink to="/groups" className={linkClass}>Groups</NavLink>}
        {isGroup && <NavLink to="/suppliers" className={linkClass}>Suppliers</NavLink>}

        {isGroup && <div className="sidebar-section">Books</div>}
        {isGroup && <NavLink to="/financials" className={linkClass}>Financials</NavLink>}
        {isGroup && <NavLink to="/trial-balance" className={linkClass}>Trial Balance</NavLink>}
        {isGroup && <NavLink to="/journal-entries" className={linkClass}>Journal Entries</NavLink>}
        {isGroup && <NavLink to="/tax" className={linkClass}>Tax</NavLink>}
        {isMaster && <NavLink to="/month-end" className={linkClass}>Month / Year End</NavLink>}
        {isGroup && <NavLink to="/reconciliation" className={linkClass}>Reconciliation</NavLink>}
        {isGroup && <NavLink to="/fixed-assets" className={linkClass}>Fixed Assets</NavLink>}
        {isGroup && <NavLink to="/ageing" className={linkClass}>Ageing</NavLink>}
      </nav>
      <div className="sidebar-footer">
        Signed in as <strong>{role}</strong>
      </div>
    </aside>
  );
};

export default Sidebar;
